import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CloseTemplatesViewColumn {
    NAME = "name",
    SERVICE = "service",
    CLIENT = "client",
    OWNER = "owner",
    BASIS = "basis",
    UPDATED = "updated",
    NUMBER_OF_APPLICATIONS = "numberOfApplications",
    LAST_APPLIED = "lastApplied",
    NUMBER_OF_TASKS = "numberOfTasks",
    NUMBER_OF_SCHEDULES = "numberOfSchedules",
    ESTIMATED_TIME = "estimatedTime",
    UPDATED_BY = "updatedBy",
    ACTIONS = "actions",
}

export enum CloseTemplatesSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    UPDATED_AT_ASC = "UPDATED_AT_ASC",
    UPDATED_AT_DESC = "UPDATED_AT_DESC",
    LAST_APPLIED_ASC = "LAST_APPLIED_ASC",
    LAST_APPLIED_DESC = "LAST_APPLIED_DESC",
    APPLICATIONS_ASC = "APPLICATIONS_ASC",
    APPLICATIONS_DESC = "APPLICATIONS_DESC",
    SCHEDULES_ASC = "SCHEDULES_ASC",
    SCHEDULES_DESC = "SCHEDULES_DESC",
    TASKS_ASC = "TASKS_ASC",
    TASKS_DESC = "TASKS_DESC",
    ESTIMATED_TIME_ASC = "ESTIMATED_TIME_ASC",
    ESTIMATED_TIME_DESC = "ESTIMATED_TIME_DESC",
    OWNER_ASC = "OWNER_ASC",
    OWNER_DESC = "OWNER_DESC",
}

const makeColumnSchema = (id: CloseTemplatesViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const CloseTemplatesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CLOSE_TEMPLATES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(CloseTemplatesViewColumn.NAME),
            makeColumnSchema(CloseTemplatesViewColumn.SERVICE),
            makeColumnSchema(CloseTemplatesViewColumn.CLIENT),
            makeColumnSchema(CloseTemplatesViewColumn.OWNER),
            makeColumnSchema(CloseTemplatesViewColumn.BASIS),
            makeColumnSchema(CloseTemplatesViewColumn.UPDATED),
            makeColumnSchema(CloseTemplatesViewColumn.NUMBER_OF_APPLICATIONS),
            makeColumnSchema(CloseTemplatesViewColumn.LAST_APPLIED),
            makeColumnSchema(CloseTemplatesViewColumn.NUMBER_OF_TASKS),
            makeColumnSchema(CloseTemplatesViewColumn.NUMBER_OF_SCHEDULES),
            makeColumnSchema(CloseTemplatesViewColumn.ESTIMATED_TIME),
            makeColumnSchema(CloseTemplatesViewColumn.UPDATED_BY),
            makeColumnSchema(CloseTemplatesViewColumn.ACTIONS),
        ]),
    ),
});

export type CloseTemplatesView = z.infer<typeof CloseTemplatesViewSchema>;
